/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { Theme, useTheme } from 'bold-ui'
import { SimNaoRadioListField, SimNaoRadioListFieldProps } from 'components/form/field/SimNaoRadioListField'
import {
  SimNaoRadioListOutroFieldProps,
  SimNaoRadioOutroListField,
} from 'components/form/field/SimNaoRadioOutroListField'

type PerguntaSimNaoRadioListFieldProps<T extends string> = Omit<SimNaoRadioListFieldProps<T>, 'labelStyle'> & {
  nameOutro?: SimNaoRadioListOutroFieldProps<T>['nameOutro']
}

export function PerguntaSimNaoRadioListField<T extends string>(props: Readonly<PerguntaSimNaoRadioListFieldProps<T>>) {
  const { label, nameOutro, ...rest } = props

  const theme = useTheme()
  const styles = createStyles(theme)

  if (nameOutro) {
    return (
      <SimNaoRadioOutroListField
        label={<span>“{label}”</span>}
        labelStyle={styles.label}
        nameOutro={nameOutro}
        {...rest}
      />
    )
  }

  return <SimNaoRadioListField label={<span>“{label}”</span>} labelStyle={styles.label} {...rest} />
}

const createStyles = (theme: Theme) => ({
  label: css`
    color: ${theme.pallete.primary.main};
  `,
})
